<template>
  <GMapMap :center="center" :zoom="zoom" map-type-id="terrain" class="tw-w-full tw-aspect-video" ref="mapRef" v-if="mapCanBeShown"></GMapMap>
  <div v-else class="tw-w-full tw-aspect-video tw-bg-gray-100 tw-grid tw-place-content-center">
    <p>Apologies, the map for this property is not available at this time.</p>
  </div>
</template>

<script setup>
import { ref, watch } from "vue";
const props = defineProps({
  map: {
    type: Object,
    required: true,
  },
});


const mapRef = ref(null);
const mapCanBeShown = ref(true);
const center = ref({ lat: 57.1499674, lng: -2.2074267 });
const zoom = ref(7);

const checkIfMapCanBeShown = () => {
  const geocoder = new window.google.maps.Geocoder();
  const setMapDetails = (location) => {
    center.value = location;
    zoom.value = 15;
    mapCanBeShown.value = true;
  };

  if (props.map.latitude && props.map.longitude) {
    setMapDetails(new google.maps.LatLng(props.map.latitude, props.map.longitude));
    return;
  }

  geocoder.geocode({ address: props.map.address }, function (results, status) {
    if (status === "OK") {
      setMapDetails(results[0].geometry.location);
    } else {
      mapCanBeShown.value = false;
    }
  });
};

const createInfoWindow = () => {
  return new window.google.maps.InfoWindow({
    content: `<div class="tw-text-center tw-text-gray-800">${props.map.address}</div>`,
  });
};

const createMarker = () => {
  return new window.google.maps.Marker({
    position: center.value,
    map: mapRef.value.$mapObject,
    title: props.map.address,
  });

  // return new google.maps.marker.AdvancedMarkerElement({
  //   map: mapRef.value.$mapObject,
  //       position: center.value,
  //       title: props.map.address,
  //   });

};

watch(mapRef, function (gMap) {
  if (gMap === null) {
    return;
  }
  gMap
    .$gmapApiPromiseLazy()
    .then(() => {
      checkIfMapCanBeShown();
      const infowindow = createInfoWindow();
      const marker = createMarker();
      infowindow.open(mapRef.value.$mapObject, marker);

      window.addEventListener("resize", function () {
        mapRef.value.$mapObject.setCenter(center.value);
      });
    })
    .catch((err) => console.error(err));
});
</script>
